import { useCallback } from "react";
import CategoryBrowser from "@/components/feature/CategoryBrowser";
import { filterTvList } from "@/utils/content";
import { movieSorts, regions, tvGenres, tvStatusFilters, years } from "@/mocks/categories";
import type { ContentItem } from "@/types/content";

const groups = [
  { key: "status", label: "更新状态", options: tvStatusFilters },
  { key: "region", label: "地区", options: regions },
  { key: "genre", label: "类型", options: tvGenres },
  { key: "year", label: "年份", options: years },
  { key: "sort", label: "排序方式", options: movieSorts.map((s) => s.label) },
];

const initialValues: Record<string, string> = {
  status: "全部状态",
  region: "全部地区",
  genre: "全部类型",
  year: "全部年份",
  sort: movieSorts[0].label,
};

export default function TvPage() {
  const filter = useCallback((values: Record<string, string>): ContentItem[] => {
    const sort = movieSorts.find((s) => s.label === values.sort)?.key ?? "release";
    return filterTvList({
      region: values.region,
      genre: values.genre,
      year: values.year,
      status: values.status,
      sort,
    });
  }, []);

  return (
    <CategoryBrowser
      heading="电视剧"
      crumbLabel="电视剧"
      description="影视工厂电视剧频道提供近期热播与全季完结的剧集资源，可按更新状态、地区、类型、年份进行筛选，并查看主演、集数与首播时间，追剧更省心。"
      groups={groups}
      initialValues={initialValues}
      filter={filter}
      emptyText="未找到符合条件的电视剧"
      pageSize={8}
    />
  );
}